export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[700px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20ecommerce%20product%20photography%20flat%20lay%20composition%20featuring%20various%20fashion%20items%20including%20white%20sneakers%20cream%20hoodie%20neutral%20toned%20accessories%20neatly%20arranged%20on%20light%20cream%20studio%20surface%20soft%20natural%20daylight%20editorial%20clean%20aesthetic%20subtle%20shadows%20airy%20atmosphere%20high%20resolution&width=1800&height=900&seq=hero-bg-main-01&orientation=landscape"
          alt="OOPBuy Spreadsheet product collection"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
      </div>

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/55 to-foreground-950/30"></div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row items-start lg:items-center gap-12 lg:gap-20">
          {/* Left: Main Content */}
          <div className="flex-1 w-full">
            {/* Social Proof */}
            <div className="flex items-center gap-3 mb-8">
              <div className="flex -space-x-2">
                <div className="w-9 h-9 rounded-full border-2 border-accent-400/60 bg-background-200 overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20portrait%20headshot%20young%20adult%20on%20light%20neutral%20studio%20background%20clean%20minimalist%20style%20natural%20expression&width=80&height=80&seq=avatar-01-user&orientation=squarish"
                  alt="User 1"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="w-9 h-9 rounded-full border-2 border-accent-400/60 bg-background-200 overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Friendly%20professional%20portrait%20headshot%20young%20woman%20on%20light%20neutral%20studio%20background%20clean%20minimalist%20style%20warm%20natural%20expression&width=80&height=80&seq=avatar-02-user&orientation=squarish"
                  alt="User 2"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="w-9 h-9 rounded-full border-2 border-accent-400/60 bg-background-200 overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20portrait%20headshot%20young%20man%20on%20light%20neutral%20studio%20background%20clean%20minimalist%20style%20confident%20natural%20expression&width=80&height=80&seq=avatar-03-user&orientation=squarish"
                  alt="User 3"
                  className="w-full h-full object-cover"
                />
              </div>
              </div>
              <span className="text-background-50/80 text-xs md:text-sm font-medium">
                Trusted by 10,000+ buyers
              </span>
            </div>

            {/* Tag */}
            <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-200/30 text-background-50 text-xs md:text-sm font-medium mb-6 border border-secondary-300/20">
              / Spreadsheet Shopping Agent
            </span>

            {/* H1 Title */}
            <h1 className="text-4xl md:text-6xl lg:text-7xl text-background-50 leading-[1.05] mb-6 max-w-2xl">
              <span className="font-bold block">OOPBuy</span>
              <span className="font-light block text-background-50/80">Spreadsheet</span>
            </h1>

            {/* Subtitle */}
            <p className="text-background-50/70 text-base md:text-lg max-w-lg mb-10 leading-relaxed">
              Learn how the OOPBuy Spreadsheet system works, compare it with traditional agents, and discover a faster, cheaper, and more transparent way to source products.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full bg-background-50 hover:bg-background-100 transition-colors text-foreground-950 font-semibold text-sm whitespace-nowrap cursor-pointer"
              >
                Start Using OOPBuy Spreadsheet
                <i className="ri-arrow-right-up-line text-lg"></i>
              </a>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full border border-background-50/30 hover:bg-background-50/10 transition-colors text-background-50 font-medium text-sm whitespace-nowrap cursor-pointer"
              >
                Explore Spreadsheet Guide
                <i className="ri-arrow-right-line text-lg"></i>
              </a>
            </div>

            {/* Trust Line */}
            <div className="flex flex-wrap gap-4 mt-8 text-background-50/60 text-xs">
              <span className="flex items-center gap-1.5">
                <i className="ri-check-line text-accent-400"></i> No hidden fees
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-check-line text-accent-400"></i> Transparent tracking
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-check-line text-accent-400"></i> Beginner friendly
              </span>
            </div>
          </div>

          {/* Right: Feature Highlight Card */}
          <div className="hidden lg:block w-full max-w-sm bg-background-50/10 backdrop-blur-sm rounded-2xl p-8 border border-background-50/10">
            <p className="text-background-50/80 text-sm leading-relaxed">
              The OOPBuy Spreadsheet system transforms how you source products — organized listings, transparent pricing, and a streamlined agent workflow all in one place. Browse categorized spreadsheets, pick your items, and let the system handle the rest.
            </p>
            <div className="mt-6 flex items-center gap-3 text-accent-400">
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-flashlight-line text-lg"></i>
              </div>
              <span className="text-xs font-semibold text-background-50/90">Faster than traditional agents</span>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-background-50/50">
        <span className="text-[10px] uppercase tracking-widest">Scroll</span>
        <div className="w-5 h-8 rounded-full border border-background-50/30 flex items-start justify-center p-1">
          <div className="w-1 h-2 rounded-full bg-background-50/50 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}